module.exports = __webpack_public_path__ + "static/media/octo_alt_funcs.ea17ae95.jpg";